export { HomeConnected as Home } from './container';
